// @flow

export const COMMAND_NEW_POLL = 'new-poll';
export const COMMAND_ANSWER_POLL = 'answer-poll';
export const COMMAND_OLD_POLLS = 'old-polls';

export const CHAR_LIMIT = 500;
export const ANSWERS_LIMIT = 255;
